module.exports = __webpack_public_path__ + "img/details.5beb1179.svg";